import axios from "axios";
import store from "../store";

class Treatments {
	create(
		project,
		format,
		tabulator_data_csv,
		name_file_tabulator,
		tags = [],
		type = "import",
		form_data = null,
		params = null,
		treatment_params = null,
		step_uid = null,
		treatment_params_config = "",
		url_files = []
	) {
		let jwt = store.state.jwt;

		var bodyFormData = form_data || new FormData();
		if (tabulator_data_csv)
			bodyFormData.append(
				"blob",
				tabulator_data_csv,
				name_file_tabulator
			);
		bodyFormData.set("project", project);
		if (format) bodyFormData.set("format", format);
		bodyFormData.set("tags", JSON.stringify(tags));
		bodyFormData.set("type", type);

		if (params)
			bodyFormData.set("params", JSON.stringify(params));
		else if (!bodyFormData.has("params"))
			bodyFormData.set("params", "[]");

		if (treatment_params)
			bodyFormData.set("treatment_params", JSON.stringify(treatment_params));
		if (step_uid)
			bodyFormData.set("step_uid", step_uid);

		if (treatment_params_config)
			bodyFormData.set("treatment_params_config", treatment_params_config)

		if (url_files)
		{
			console.log("url_files")
			console.log(url_files)
			bodyFormData.set("url_files", JSON.stringify(url_files));
		}

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/treatments",
					bodyFormData,
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async stop(id)
	{
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/treatments/" + id + "/stop",
					{},
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	get(id, key) {
		var headers = {};

		if (key)
		{
			headers = {
				key: key
			}
		}

		if (store.state.jwt)
		{
			let jwt = store.state.jwt;

			headers = {
				Authorization: "bearer " + jwt,
			};
		}

		return new Promise(function (resolve, reject) {
			axios
				.get(`${process.env.VUE_APP_SAAS_BACK}` + "/treatments/" + id, {
					headers: headers,
				})
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	getAll(id, page, nb = 30, env = -1) {

		var env = "";
		if (env != -1)
			env = "&env="+env

		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.get(
					`${process.env.VUE_APP_SAAS_BACK}` +
						"/treatments/projects/" +
						id +
						"?offset=" +
						page +
						"&sort=dateheureDebut&limit=" + nb + "&dir=DESC" + env,
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	getAllId(id, page, nb = 30, env = -1) {

		var env = "";
		if (env != -1)
			env = "&env="+env

		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.get(
					`${process.env.VUE_APP_SAAS_BACK}` +
						"/treatments/project/" +
						id +
						"?offset=" +
						page +
						"&sort=dateheureDebut&limit=" + nb + "&dir=DESC" + env,
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve((response.data.treatments && response.data.treatments.length > 0) ? response.data.treatments[0] : null);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	getAllNoLimit(id, offset, limit) {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.get(
					`${process.env.VUE_APP_SAAS_BACK}` +
						"/treatments/projects/" +
						id +
						"?offset=" +
						offset +
						"&limit=" +
						limit +
						"&sort=dateheureDebut&dir=DESC",
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	getFiles(id) {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.get(
					`${process.env.VUE_APP_SAAS_BACK}` +
						"/treatments/" +
						id +
						"/treatment_files",
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response.data.treatment_files);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	getLogs(id) {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.get(
					`${process.env.VUE_APP_SAAS_BACK}` +
						"/treatments/" +
						id +
						"/logs",
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response.data.logs);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	getMeters(id) {
		return new Promise(function (resolve, reject) {
			let jwt = store.state.jwt;
			axios
				.get(
					`${process.env.VUE_APP_SAAS_BACK}` +
						"/treatments/" +
						id +
						"/meters",
					{
						headers: {
							Authorization: "bearer " + jwt,
						},
					}
				)
				.then(function (response) {
					resolve(response.data.meters);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async getFile(id, name, dowload = true, response_type = "blob") {
		let jwt = store.state.jwt;

		var opts = {
			headers: {
				Authorization: "bearer " + jwt,
			},
		};

		if (response_type) opts.responseType = response_type;

		return axios
			.get(`${process.env.VUE_APP_SAAS_BACK}` + "/files/" + id, opts)
			.then((response) => {
				if (dowload) {
					const url = window.URL.createObjectURL(
						new Blob([response.data])
					);
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", name);
					document.body.appendChild(link);
					link.click();
				} else return response.data;
			});
	}

	async getFileAlyx(
		url,
		dowload = true,
		response_type = "blob",
		dowload_name = ""
	) {
		let jwt = store.state.jwt;

		var opts = {
			headers: {
				Authorization: "bearer " + jwt,
			},
		};

		if (response_type) opts.responseType = response_type;

		return axios
			.post(
				`${process.env.VUE_APP_SAAS_BACK}` + "/files/alyx_user",
				{ url: url /*.slice(0, url.lastIndexOf('/'))*/ },
				opts
			)
			.then((response) => {
				console.log("response")
				if (dowload) {
					const url = window.URL.createObjectURL(
						new Blob([response.data])
					);
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", dowload_name || name);
					document.body.appendChild(link);
					link.click();
				} else return response.data;
			})
			.catch(function (error) {
				console.log(error)
				return null;
			});
	}

	async getHeadFile(id) {
		let jwt = store.state.jwt;

		return axios
			.head(`${process.env.VUE_APP_SAAS_BACK}` + "/files/" + id, {
				headers: {
					Authorization: "bearer " + jwt,
				},
			})
			.then((response) => {
				return response;
			});
	}
}

export default new Treatments();
